export enum AccountStatus {
  NonExistent = 'non-existent',
  Invalid = 'invalid',
  Valid = 'valid',
}

export type UseContainerProps = {
  onClosePopup?: () => void;
  onNewValidEmailConnection?: () => void;
};

export type Signature = {
  id?: number;
  body: string | null | undefined;
};

export type CandidateEmailSettingsState = {
  handleCloseConnectEmailModal: () => void;
  handleOpenMailContactModal: () => void;
  onCloseOAuthPopupCallbackRef: React.MutableRefObject<VoidCallback | null>;
  currentEmailStatus: AccountStatus;
  currentCalendarStatus: AccountStatus;
  isLoadingEmailStatus: boolean;
  openOAuthPopup: () => void;
};
